import { render, staticRenderFns } from "./MemoCard.vue?vue&type=template&id=030af5b5"
import script from "./MemoCard.vue?vue&type=script&lang=js"
export * from "./MemoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports